module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": item.children[0].name
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      class: {
        'menu-center': _vm.isShrinkage
      },
      attrs: {
        "index": item.name,
        "id": item.authority
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": item.name
      }
    }, [(item.icon) ? _c('icon-svg', {
      class: {
        'clear-margin': _vm.isShrinkage
      },
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      class: {
        'hide-el': _vm.isShrinkage
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        ref: "child_el_menu_item",
        refInFor: true,
        class: [{
          'menu-item-width': _vm.isShrinkage
        }, 'switch-el-menu-item'],
        attrs: {
          "index": item.path + '/' + child.path,
          "id": child.path
        }
      }, [_c('a', {
        attrs: {
          "href": "javascript:void(0)",
          "title": child.name
        }
      }, [(child.icon) ? _c('icon-svg', {
        class: {
          'clear-margin': _vm.isShrinkage
        },
        attrs: {
          "icon-class": child.icon
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('span', {
        class: {
          'offset-margin': _vm.isShrinkage
        }
      }, [_vm._v(_vm._s(child.name))])])], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2320244c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2320244c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = fUFR
// module chunks = 101